import { render } from "./cutomize.vue?vue&type=template&id=709ce212"
import script from "./cutomize.vue?vue&type=script&lang=ts"
export * from "./cutomize.vue?vue&type=script&lang=ts"

import "./cutomize.vue?vue&type=style&index=0&id=709ce212&lang=css"
script.render = render

export default script